import { render, staticRenderFns } from "./OperarioDocumento.vue?vue&type=template&id=70e80f22"
import script from "./OperarioDocumento.vue?vue&type=script&lang=js"
export * from "./OperarioDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports